import React, { useRef, useState, useEffect } from 'react';
import { Form, Row, Col, Card, Datepicker,Button, Modal, Table, CloseButton } from 'react-bootstrap';
import ErrorHandler from '../../controls/ErrorHandler';
import Icon from "../../controls/Icons/Icon";
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { dateDisplayFormater, getDateSaveFormat } from '../../../Utils';
import DynamicDropdownSearchable from '../../controls/DynamicDropdownSearchable';
import useFetchWithCancellation from '../../../customhooks/useFetchWithCancellation';
import InvoicePayInUpdateTransaction from './InvoicePayInUpdateTransaction';
export default function InvoicePayInUpdate({ rowData, afterSave }) {
    const [validated, setValidated] = useState(false);
    const formRef = useRef(null);
    const state = useSelector(state => state);
    const [isInvSelected, setisInvSelected] = useState(false);
   const [data, setData] = useState(null);
    const [FMSRCName, setFMSRCName] = useState();
    const [invoiceDate, setinvoiceDate] = useState();
    const { fetchData } = useFetchWithCancellation();
    const [totalRecAmt, settotalRecAmt] = useState(0);
    const [modeofPayment, setmodeofPayment] = useState("");
    const [paymentRecdDate, setpaymentRecdDate] = useState(new Date());
    const [refreshGrid, setrefreshGrid] = useState(false);
    const [showTransactions, setshowTransactions] = useState(false);

    const [gridData, setgridData] = useState({
        fkinvoiceId: state.selPayUpdtData.Id ?? 0,
        ReceivedAmount: 0,
        PaymentNotes: "",
        CreatedDate: "",
        UpdatedDate: "",
        CreatedBy: "",
        ModifiedBy: "",
        ModeofPayment: "",
        paymentRecdDate: "",
    });

    const [savedata, setsavedata] = useState({
        fkinvoiceId: 0,
        ReceivedAmount: 0,
        PaymentNotes: "",
        ModeofPayment: "",
        paymentRecdDate: "",
        InvoicetypeId: 0,
        CreatedBy: JSON.parse(localStorage.getItem("user")).Id,
        ModifiedBy:JSON.parse(localStorage.getItem("user")).Id,
    });
    const navigate = useNavigate();
    const handleModofPayment = (e) => {
        if (e.target.value !== '') {
            setmodeofPayment(e.target.value);
            setsavedata(c => ({ ...c, "ModeofPayment": e.target.value }));
        } else {
            
            window.alert("Please select the Mode of Payment");
            setmodeofPayment("");
            setsavedata(c => ({ ...c, "ModeofPayment": "" }));
           // e.target.value = '';
            e.target.focus();
            return false;
        }
    };

    useEffect(() => {
        if (state.selPayUpdtData && state.selPayUpdtData.Id > 0) {
            setData(state.selPayUpdtData);
            console.log(state.selPayUpdtData);
            setsavedata(c => ({ ...c, "fkinvoiceId": state.selPayUpdtData.Id }));
            // console.log(date)
            // var invDate = new Date(state.selPayUpdtData.InvoiceDate);
            setinvoiceDate(dateDisplayFormater(state.selPayUpdtData.InvoiceDate));
            if (state.selPayUpdtData.FMSName) {
                setFMSRCName(state.selPayUpdtData.FMSName);
            }
            if (state.selPayUpdtData.RCName) {
                setFMSRCName(state.selPayUpdtData.RCName);
            }
           // console.log(invoiceDate);
            setisInvSelected(true);
        } else {
            setisInvSelected(false);
        }
    }, []);

    useEffect(() => {

        if (state.selPayUpdtData && state.selPayUpdtData.Id > 0) {
            fetch(state.projectdetail.API + "/invoice/GetAllInvReceivedAmt?InvId=" + state.selPayUpdtData.Id, {
                method: "Get"
            }).then(response => response.json()).then((res) => {
                if (res > 0) {
                    settotalRecAmt(res);
                }
                //navigate("/admin/invoice");
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("Invoice.js ==> Invoice Get", null, null, err);
                console.log(err)
            }).finally(() => {
                //setLoading(false);
            });
        }

    }, [refreshGrid]);

    //useEffect(() => {

    //    if (state.selPayUpdtData && state.selPayUpdtData.Id > 0) {
    //        fetch(state.projectdetail.API + "/invoice/GetAllInvReceivedAmtDetails?InvId=" + state.selPayUpdtData.Id, {
    //            method: "Get"
    //        }).then(response => response.json()).then((res) => {
    //            if (res) {
    //                setgridData(res);
    //                console.log(res);
    //            }
    //            //navigate("/admin/invoice");
    //        }).catch((err) => {
    //            if (err && err.name === 'AbortError') return;
    //            window.HandleError("Invoice.js ==> Invoice Get", null, null, err);
    //            console.log(err)
    //        }).finally(() => {
    //            //setLoading(false);
    //        });
    //    }

    //}, [refreshGrid]);


    const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (e.target.type === "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        if (name == 'ReceivedAmount') {
            if (isNaN(value)) {
                e.target.value = 0;
                e.target.focus();
                return false;
            }
        }
        setsavedata(c => ({ ...c, [name]: value }));
    });

    const SaveData = (e) => {
        if (data.Id > 0) {
            if (savedata.ModeofPayment == "") {
                window.alert(" Please select Mode of Payment");
                return false;
            }

            if (savedata.PaymentNotes == "") {
                window.alert(" Please enter Payment details");
                return false;
            }
            let totrecAmt = 0;
            if (totalRecAmt > 0) {
                totrecAmt = parseFloat(totalRecAmt) + parseFloat(savedata.ReceivedAmount);
            } else {
                totrecAmt = parseFloat(savedata.ReceivedAmount);
            };
            let updtStatus = "";
            if (totrecAmt > data.InvoiceAmount) {
                window.alert(" Paid Amount is exceeding Invoice Amout.Please verify and update");
                return false;
            }
            if (totrecAmt < data.InvoiceAmount) {
                updtStatus = "Partial Payment Recd";
            }
            if (totrecAmt == data.InvoiceAmount) updtStatus = "Full Payment Recd";

            savedata.paymentRecdDate = getDateSaveFormat(paymentRecdDate);
           // console.log(savedata);
            fetchData(state.projectdetail.API + "/invoice/SaveInvReceiveAmt?status=" + updtStatus, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(savedata)
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    setsavedata(res);
                    window.toast("Invoice saved sucessfully");
                    setValidated(false);
                    setrefreshGrid(!refreshGrid);
                    
                    // setSavedSuccessfully(true);
                  //  let savedstatus = true;
                    // afterSave(savedstatus);
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("InvoicePayInUpdate.js ==> InvPayInUpdate save", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
               // setLoading(false);
                // dispatch({ type: UpdtInvoiceContAction.ClearInvoiceContent });
                afterSave(true);
               // navigate("/admin/invoice");
            });
              
        }
    }
    const CloseTransactions = () => {
        setshowTransactions(false);
    }
    const viewTransactions = () => {
        setshowTransactions(true);

    }
    const handleCancel = () => {
        console.log("cancel button clicked")
    }
    //const handleChange = (e) => {
    //    console.log("Drop down value changed");
    //    console.log(e.target.value);
    //}
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <div>
                <div>
                    Pay-In Update Screen
                    {!isInvSelected &&
                        <div>Please select invoice for update the payment</div>
                    }
                    {isInvSelected &&
                        <div>
                            
                            <Card className="border">
                                <Card.Body>
                                    <Row>
                                        <Col md={3}>
                                            Invoice Amount:
                                        </Col>
                                        <Col md={2}>
                                            <Form.Control type="text" name="totalRecAmt" value={data.InvoiceAmount} autoComplete="off" />
                                        </Col>
                                        <Col md={3}> Payment Recd Date</Col>
                                        <Col md={4}>
                                            <DatePicker required={true} className="form-control" selected={paymentRecdDate} onChange={(date) => setpaymentRecdDate(date)}
                                                showYearDropdown
                                                showMonthDropdown
                                                dateFormat="MM-dd-yyyy"
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        &nbsp;
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            Total Received Amount:
                                        </Col>
                                        <Col md={2}>
                                            <Form.Control type="text" name="totalRecAmt" value={totalRecAmt} autoComplete="off" />
                                        </Col>
                                        <Col md={3}>
                                            
                                            <Form.Label>Mode of Payment<code className='required-symbol'></code></Form.Label>
                                        </Col>
                                        <Col md={4}>
                                                <Form.Select
                                                    as="select"
                                                    value={modeofPayment}
                                                    onChange={handleModofPayment}
                                                >
                                                    <option value="">Select Mode of Payment</option>
                                                <option value="Account Transfer">Account Transfer</option>
                                                    <option value="Cheque">Cheque</option>
                                                    <option value="Zelle">Zelle</option>
                                                </Form.Select>
                                        </Col>
                                    </Row>
                                     <Row>
                                        &nbsp;&nbsp;&nbsp;
                                    </Row>
                                    <Row>
                                        <Col md={3}>
                                            Enter Received Amount:
                                        </Col>
                                        <Col md={2}>
                                            <Form.Control type="text" name="ReceivedAmount" onChange={(e) => { handleChange(e) }} value={savedata.ReceivedAmount} />
                                        </Col>
                                        <Col md={3}>
                                                <Form.Label>Payment Notes<code className='required-symbol'></code></Form.Label>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Control as="textarea" rows={4} name="PaymentNotes" onChange={(e) => { handleChange(e) }} value={savedata.PaymentNotes} autoComplete="off" />
                                        </Col>
                                    </Row>
                                    {/*<Row>*/}
                                    {/*    <Col md={8}></Col>*/}
                                    {/*    <Col md={4}>*/}
                                    {/*        <Form.Group>*/}
                                    {/*            <Button type="button" id="Save" name="Save" onClick={SaveData} className="me-2" variant="primary">Save</Button>*/}
                                    {/*            &nbsp;&nbsp;&nbsp;&nbsp;*/}
                                    {/*            <Button type="button" onClick={handleCancel} className="me-2" variant="primary">Cancel</Button>*/}
                                    {/*        </Form.Group>*/}
                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                    <Row>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </Row>
                                    {/*<Row>*/}
                                    {/*    <Col md={12}>*/}
                                    {/*        <Table>*/}
                                    {/*            <thead>*/}
                                    {/*                <th>S.No</th>*/}
                                    {/*                <th>Client Name</th>*/}
                                    {/*                <th>Invoice Number</th>*/}
                                    {/*                <th>Invoice Date</th>*/}
                                    {/*                <th>Invoice Amount</th>*/}
                                    {/*                <th>Received Amount</th>*/}
                                    {/*                */}{/*<th>Payment Notes</th>*/}
                                    {/*            </thead>*/}
                                    {/*            <tr>*/}
                                    {/*                <td>1</td>*/}
                                    {/*                <td>{data.ClientName}</td>*/}
                                    {/*                <td>{data.InvoiceNumber}</td>*/}
                                    {/*                <td>{dateDisplayFormater(data.InvoiceDate)}</td>*/}
                                    {/*                <td>{data.InvoiceAmount}</td>*/}
                                    {/*                <td><Form.Control type="text" name="ReceivedAmount" onChange={(e) => { handleChange(e) }} value={savedata.ReceivedAmount}></Form.Control></td>*/}
                                    {/*                */}{/*<td>{savedata.PaymentNotes}</td>*/}
                                                    
                                    {/*            </tr>*/}

                                    {/*        </Table>*/}


                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                    <Row>
                                        <Col md={6}></Col>
                                       
                                        <Col md={6}>
                                            <Button type="button" id="Transactions" name="Transactions" style={{ align: 'right' }} onClick={viewTransactions} className="me-2" variant="primary">View Transactions</Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button type="button" id="Save" name="Save" onClick={SaveData} className="me-2" variant="primary">Update Payment</Button>   
                                        </Col>
                                    </Row>

                                    <Modal size="lg" show={showTransactions} onHide={CloseTransactions} backdrop="static">
                                        <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                                            <h4>Pay In Transactions</h4>
                                            <CloseButton onClick={CloseTransactions} className="btn-close" />
                                        </Modal.Header>
                                        <Modal.Body>
                                            <InvoicePayInUpdateTransaction invId={state.selPayUpdtData.Id ?? 0} onCancel={CloseTransactions} />
                                        </Modal.Body>
                                    </Modal>
                                    {/*<Row>&nbsp;</Row>*/}
                                    {/*<Row>*/}
                                    {/*    <Col md={3} style={{ border: "1px solid #ccc" }}> Entered By</Col>*/}
                                    {/*    <Col md={2} style={{ border: "1px solid #ccc" }}> Received Amt</Col>*/}
                                    {/*    <Col md={2} style={{ border: "1px solid #ccc" }}> Mode</Col>*/}
                                    {/*    <Col md={3} style={{ border: "1px solid #ccc" }}> Payment Notes</Col>*/}
                                    {/*    <Col md={2} style={{ border: "1px solid #ccc" }}> Created Date</Col>*/}
                                    {/*</Row>*/}
                                    {/*{gridData && gridData.length > 0 && gridData.map((rowData) => {*/}
                                    {/*    return (*/}
                                    {/*        <Row>*/}
                                    {/*            <Col md={3} style={{ border: "1px solid #ccc" }}>*/}
                                    {/*                {rowData.CreatedBy}*/}
                                    {/*            </Col>*/}
                                    {/*            <Col md={2} style={{ border: "1px solid #ccc" }}>*/}
                                    {/*                {rowData.ReceivedAmount}*/}
                                    {/*            </Col>*/}
                                    {/*            <Col md={2} style={{ border: "1px solid #ccc" }}>*/}
                                    {/*                {rowData.ModeofPayment}*/}
                                    {/*            </Col>*/}
                                    {/*            <Col md={3} style={{ border: "1px solid #ccc" }}>*/}
                                    {/*                {rowData.PaymentNotes}*/}
                                    {/*            </Col>*/}
                                    {/*            <Col md={2} style={{ border: "1px solid #ccc" }}>*/}
                                    {/*                {dateDisplayFormater(rowData.CreatedDate)}*/}
                                    {/*            </Col>*/}

                                    {/*        </Row>*/}
                                    {/*    )*/}
                                    {/*}) }*/}
                                    {/*<Row></Row>*/}
                                </Card.Body>
                            </Card>
                        </div>
                    }
                </div>
            </div>
        </Form>
    </ErrorBoundary>
    );
};